// extracted by mini-css-extract-plugin
export default {"board":"SnakeBoard_board__Qr9sB"};